<template>
  <v-card>
    <div class="header d-flex justify-center py-3">
      {{ title }}
      <v-btn
        absolute
        right
        width="20"
        height="20"
        icon
        plain
        @click="$emit('close')"
      >
        <v-icon size="20">close</v-icon>
      </v-btn>
    </div>
    <div class="px-4 pb-4">
      <v-divider class="mb-3" />
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BaseReviewMemberPopup',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
};
</script>

<style lang="scss" scoped>
.header {
  // Make relative to assist positioning the close button
  position: relative;

  & .close-button {
    // Position close button to the right of the header
    position: absolute;
    right: 0;
    top: 0;
  }

  line-height: 20px;
  font-weight: bold;
}
</style>
